<template>
  <b-container fluid>
    <b-row>
      <b-col cols="10" offset="1">
      <h3>{{ $t('LNG_BAREME_MANAGEMENT', this.lang) }}</h3>
      </b-col>
    </b-row>
     
    <b-row>
      <b-col cols="8" offset="2">
        <b-row class="syscoBox text-left">
          <b-col cols="12" id="testContent" class="text-white bg-evaobj pt-2">
            <h5><span class="align-middle">{{ $t('LNG_EVALUATION_INFORMATION', this.lang) }}</span></h5>
          </b-col>   
          <b-col cols="12" id="testContent" class="mt-3">
              <h5>{{ $t('LNG_NAME', this.lang) }}: {{this.testName}}<br/>{{ $t('LNG_DISCIPLINE', this.lang) }}: {{this.testDiscipline}}<br/>{{ $t('LNG_DATE', this.lang) }}: {{testDateFormatted}}<br/><br/>
              {{$t('LNG_TOTAL_POINTS', this.lang)}}: {{this.totalPoints}} pts</h5>
           </b-col>
           <b-col cols="12" v-if="this.testComment !== ''">
              <span><pre>{{ this.testComment }}</pre></span>
           </b-col>
        </b-row>
      </b-col>
    </b-row>
    
     <b-row>
       <b-col cols="1" offset="2">{{ $t('LNG_GRADE', this.lang) }}</b-col>
       <b-col cols="1">{{ $t('LNG_MIN_POINTS', this.lang) }}</b-col>
       <b-col cols="2" class="text-left">{{ $t('LNG_NUMBER_STUDENTS', this.lang) }}</b-col>
     </b-row>
     
     <div v-for="(b, indexe) in bareme">
       <b-row>
         <b-col cols="1"  offset="2">{{ b.label }}</b-col>
         <b-col cols="1"><b-form-input v-model="b.min" type="text" placeholder="Pts" v-on:change="saveGrade(b, true)" /></b-col>
         <b-col cols="2" class="text-left"><img class="tally" :src="b.src1" v-if="b.src1 !== ''"/> <img class="tally" :src="b.src2" v-if="b.src2 !== ''"/> <img class="tally" :src="b.src3" v-if="b.src3 !== ''"/> <img class="tally" :src="b.src4" v-if="b.src4 !== ''"/></b-col>
       </b-row>
     </div>
     
     <b-row class="mt-5">
       <b-col cols="3"  offset="2">
         <b-button type="button" variant="evaobj" v-on:click.prevent="printBareme('printSimpleBareme')" block><span class="fa fa-print fa-lg" aria-hidden="true"></span>  {{ $t('LNG_PRINT', this.lang) }}</b-button>
       </b-col>
       <b-col cols="3">
         <b-button type="button" variant="evaobj" v-on:click.prevent="printBareme('printDetailedBareme')" block><span class="fa fa-print fa-lg" aria-hidden="true"></span> {{ $t('LNG_PRINT_DETAILLE', this.lang) }}</b-button>
       </b-col>
     </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'bareme',
  components: {
  },
  data () {
    return {
      testName: '',
      testDiscipline: '',
      testComment: '',
      testDateFormatted: '',
      bareme: [],
      percentSuf: '',
      totalPoints: 0.0
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadTestData()
    this.loadBareme()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ])
  },
  methods: {
    back: function () {
      this.$router.push({ path: '/testEdit/' + this.$route.params.testId })
    },
    loadTestData: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.testName = response.data.name
        this.testDiscipline = response.data.discipline
        this.testComment = response.data.comment
        this.testDateFormatted = ''
        if (moment(response.data.date).isValid()) {
          this.testDateFormatted = moment(response.data.date).format('DD.MM.YYYY')
        }
        this.totalPoints = response.data.totalPts
      })
    },
    loadBareme () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getBaremeData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        while (this.bareme.length > 0) {
          this.bareme.pop()
        }
        response.data.bareme.forEach((o) => {
          this.bareme.push({id: o.id, label: o.label, min: o.min, src1: o.studentNumber1, src2: o.studentNumber2, src3: o.studentNumber3, src4: o.studentNumber4})
        })
        this.percentSuf = response.data.suff
      })
    },
    saveGrade (row, propagate) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'saveGrade',
          id: row.id,
          min: row.min,
          test: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.loadBareme()
      })
    },
    printBareme (method) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: method,
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        window.open(this.api + '?method=getPdf&name=' + response.data.name + '&clientname=bareme')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// bareme.vue?2aba0806